import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/home.vue'
import Gallery from '@/views/gallery.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/gallery', name: 'Gallery', component: Gallery }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // jeśli użytkownik kliknął "back" lub "forward", zachowaj pozycję
    if (savedPosition) {
      return savedPosition
    } 
    // w przeciwnym razie przewiń na górę
    return { top: 0 }
  }
})

export default router